import Vue from 'vue';
import VueResource from 'vue-resource';
import converterMoeda from '~js/converter-moeda';
import formatarData from '~js/formatar-data';
import converterObjetoFormData from '~js/converter-objeto-formdata';
import salvarArquivo from '~js/salvar-arquivo';

Vue.use(VueResource);

async function normalizarParaSalvar(solicitacao) {
  delete solicitacao.projeto;
  delete solicitacao.protocolo;

  if (solicitacao.dataNascimento) {
    solicitacao.dataNascimento = await formatarData.paraNumero(solicitacao.dataNascimento);
  }

  if (solicitacao.dataInicioContratacao) {
    solicitacao.dataInicioContratacao = await formatarData.paraNumero(solicitacao.dataInicioContratacao);
  }

  if (solicitacao.dataFimContratacao) {
    solicitacao.dataFimContratacao = await formatarData.paraNumero(solicitacao.dataFimContratacao);
  }
}

async function normalizarParaVisualizar(solicitacao) {
  solicitacao.eventos.map(evento => {
    evento.valorEstimado = converterMoeda.paraReal(evento.valorEstimado);

    return evento;
  });

  solicitacao.salarioBruto = converterMoeda.paraReal(solicitacao.salarioBruto);

  if (solicitacao.dataInicioContratacao) {
    solicitacao.dataInicioContratacao = await formatarData.paraData(solicitacao.dataInicioContratacao);
  }
  else
    solicitacao.dataInicioContratacao = '';

  if (solicitacao.dataFimContratacao) {
    solicitacao.dataFimContratacao = await formatarData.paraData(solicitacao.dataFimContratacao);
  }
  else
    solicitacao.dataFimContratacao = '';

  switch (solicitacao.tipoSolicitacao) {
    case 1:
      solicitacao.tipoSolicitacao = "1"
      break
    case 2:
      solicitacao.tipoSolicitacao = "2"
      break
    case 3:
      solicitacao.tipoSolicitacao = "3"
      break
    case 4:
      solicitacao.tipoSolicitacao = "4"
      break
    default:
      solicitacao.tipoSolicitacao = "0"
  }

  return solicitacao;
}

export default {
  lista: (pagina = 1, filtros) => {
    const parametros = Object.assign({}, { pagina }, filtros);

    const periodo = parametros.periodo;
    delete parametros.periodo;

    if (periodo) {
      parametros.dataInicio = moment(periodo[0], 'DD/MM/YYYY').format('MM/DD/YYYY');
      parametros.dataFim = moment(periodo[1], 'DD/MM/YYYY').format('MM/DD/YYYY');
    }

    return Vue.http.get('/api/SolicitacaoContratacaoPessoal', { params: parametros });
  },
  adicionar: async (solicitacao, arquivos) => {
    await normalizarParaSalvar(solicitacao);
    solicitacao.arquivos = arquivos;

    solicitacao = await converterObjetoFormData(solicitacao);

    return Vue.http.post('/api/SolicitacaoContratacaoPessoal', solicitacao).then(res => res.data.id);
  },
  alterar: async (solicitacao, arquivos, id) => {
    await normalizarParaSalvar(solicitacao);
    solicitacao.arquivos = arquivos;

    solicitacao = await converterObjetoFormData(solicitacao);

    return Vue.http.put(`/api/SolicitacaoContratacaoPessoal/${id}`, solicitacao).then(res => res.data.id);
  },
  obterPorId: id => {
    return Vue.http.get(`/api/SolicitacaoContratacaoPessoal/${id}`)
      .then(response => normalizarParaVisualizar(response.data));
  },
  liberar: id => {
    return Vue.http.post(`/api/SolicitacaoContratacaoPessoal/${id}/liberar`)
      .then(response => response.data);
  },
  cancelar: id => {
    return Vue.http.post(`/api/SolicitacaoContratacaoPessoal/${id}/cancelar`)
      .then(response => response.data);
  },
  reenviarEmail: id => {
    return Vue.http.get(`/api/SolicitacaoContratacaoPessoal/${id}/reenviaremail`)
      .then(response => response.data);
  },
  arquivos: id => {
    return Vue.http.get(`/api/SolicitacaoContratacaoPessoal/${id}/arquivos`)
      .then(response => response.data);
  },
  download: (id, arquivo) => {
    return Vue.http.get(`/api/SolicitacaoContratacaoPessoal/${id}/downloadarquivo/${arquivo}`,
        {
          responseType: 'blob'
        })
      .then(response => {
        return salvarArquivo(response, arquivo);
      });
  },
  eventos: (tipoSolicitacao) => {
    if (tipoSolicitacao > 0)
      return Vue.http.get(`/api/SolicitacaoContratacaoPessoal/${tipoSolicitacao}/beneficios`).then(response => response.data);
    else
      return [];
  }
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-contratacao-pessoal/servico.js